import { render, staticRenderFns } from "./count-up.vue?vue&type=template&id=cd13131a&scoped=true&"
import script from "./count-up.ts?vue&type=script&lang=ts&"
export * from "./count-up.ts?vue&type=script&lang=ts&"
import style0 from "./count-up.scss?vue&type=style&index=0&id=cd13131a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13131a",
  null
  
)

export default component.exports